import { render, staticRenderFns } from "./DashboardReports.vue?vue&type=template&id=147cd536&"
import script from "./DashboardReports.vue?vue&type=script&lang=js&"
export * from "./DashboardReports.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports